const ERROR_KEYS = {
  DROPBOX_PRO_REQUIRED: 'dropbox.errors.proRequired',
  DROPBOX_INVALID_LINK: 'dropbox.errors.invalidLink',
  DROPBOX_FOLDER_UNSUPPORTED: 'dropbox.errors.folderUnsupported',
  DROPBOX_UNAVAILABLE: 'dropbox.errors.unavailable',
  DROPBOX_UNSUPPORTED_MEDIA: 'dropbox.errors.unsupportedMedia',
  DROPBOX_FILE_TOO_LARGE: 'dropbox.errors.fileTooLarge',
  DROPBOX_SOURCE_CHANGED: 'dropbox.errors.sourceChanged',
  DROPBOX_METADATA_TIMEOUT: 'dropbox.errors.metadataTimeout',
  DROPBOX_STORAGE_UNAVAILABLE: 'dropbox.errors.storageUnavailable',
  DROPBOX_DOWNLOAD_FAILED: 'dropbox.errors.downloadFailed',
  DROPBOX_PROCESSING_FAILED: 'dropbox.errors.processingFailed',
} as const;

export type DropboxErrorCode = keyof typeof ERROR_KEYS;

// Inspect only known Apollo error containers, never expose provider messages.
export function getDropboxErrorCode(value: unknown, depth = 0): DropboxErrorCode | null {
  if (!value || typeof value !== 'object' || depth > 3) return null;
  const error = value as Record<string, unknown>;
  const extensions = error.extensions as Record<string, unknown> | undefined;
  for (const candidate of [extensions?.code, error.code, error.message]) {
    if (typeof candidate === 'string' && Object.prototype.hasOwnProperty.call(ERROR_KEYS, candidate)) return candidate as DropboxErrorCode;
  }
  const nestedError = getDropboxErrorCode(error.error, depth + 1);
  if (nestedError) return nestedError;
  for (const list of [error.graphQLErrors, error.errors]) {
    if (!Array.isArray(list)) continue;
    for (const item of list.slice(0, 20)) {
      const code = getDropboxErrorCode(item, depth + 1);
      if (code) return code;
    }
  }
  return null;
}

export function getDropboxErrorKey(error: unknown): string {
  return ERROR_KEYS[getDropboxErrorCode(error) ?? 'DROPBOX_UNAVAILABLE'];
}
